import React from "react";
import { Box, Checkbox, FormControlLabel } from "@mui/material";
import CampaignSettingsDetails from "./CampaignSettingsDetails";
import MonthlyBudgetCap from "./MonthlyBudgetCap";
import LanguageSelection from "./LanguageSelection";
import TargetLocations from "./TargetLocations";
import "./CampaignSettingsAccordion.scss";
import PlacementDetails from "./PlacementDetails/PlacementDetails";
import AttributionSettings from "./AttributionSettings/AttributionSettings";

const CampaignSettingsAccordion = ({
  biddingStrategy,
  setBiddingStrategy,
  campaignName,
  setCampaignName,
  campaignBudget,
  setCampaignBudget,
  selectedLanguage,
  setSelectedLanguage,
  selectedCountries,
  setSelectedCountries,
  targetValue,
  setTargetValue,
  monthlyBudget,
  setMonthlyBudget,
  errors,
  dailyBudgetCap,
  setDailyBudgetCap,
  placementDetails,
  setPlacementDetails,
  isEdit = false,
  currencySymbol,
  campaignId = null,
  clickThroughValue,
  setClickThroughValue,
  viewThroughValue,
  setViewThroughValue,
  selectedHotels,
  setSelectedHotels,
  isMultiHotelEnabled = false,
  lockedHotels = [],
}) => {
  return (
    <Box className="meta-travel-ads-form-campaign-settings">
      <CampaignSettingsDetails
        biddingStrategy={biddingStrategy}
        setBiddingStrategy={setBiddingStrategy}
        campaignName={campaignName}
        setCampaignName={setCampaignName}
        campaignBudget={campaignBudget}
        setCampaignBudget={setCampaignBudget}
        errors={errors}
        isEdit={isEdit}
        currencySymbol={currencySymbol}
        campaignId={campaignId}
        selectedHotels={selectedHotels}
        setSelectedHotels={setSelectedHotels}
        isMultiHotelEnabled={isMultiHotelEnabled}
        lockedHotels={lockedHotels}
      />

      <MonthlyBudgetCap
        monthlyBudget={monthlyBudget}
        setMonthlyBudget={setMonthlyBudget}
        targetValue={targetValue}
        setTargetValue={setTargetValue}
        errors={errors}
        dailyBudgetCap={dailyBudgetCap}
        setDailyBudgetCap={setDailyBudgetCap}
        isEdit={isEdit}
        currencySymbol={currencySymbol}
      />
      <PlacementDetails
        placementDetails={placementDetails}
        setPlacementDetails={setPlacementDetails}
        errors={errors}
      />
      <AttributionSettings 
      clickThroughValue={clickThroughValue}
      setClickThroughValue={setClickThroughValue}
      viewThroughValue={viewThroughValue}
      setViewThroughValue={setViewThroughValue}
      />
      <LanguageSelection
        selectedLanguage={selectedLanguage}
        setSelectedLanguage={setSelectedLanguage}
        errors={errors}
      />
      <TargetLocations
        selectedCountries={selectedCountries}
        setSelectedCountries={setSelectedCountries}
      />
    </Box>
  );
};

export default CampaignSettingsAccordion;
